<template>
  <form method="post" @submit.prevent="onSend">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title is-centered">
          {{ formTitle + $t('attributes.link') }}
        </p>
      </header>
      <section class="modal-card-body">
        <form-wrapper :validator="$v.form">
          <form-group
            horizontal
            name="sort"
            attribute="attributes.sort"
            :label="$t('attributes.sort')"
          >
            <b-select v-model="form.sort" name="sort">
              <option
                v-for="option in sort_range"
                :key="option"
                :value="option"
              >
                {{ option }}
              </option>
            </b-select>
          </form-group>
          <form-group
            horizontal
            name="pc_show"
            attribute="attributes.pc"
            :label="$t('attributes.pc') + $t('attributes.display')"
          >
            <b-switch v-model="form.pc_show" name="pc_show"></b-switch>
          </form-group>
          <form-group
            horizontal
            name="mobile_show"
            attribute="attributes.mobile"
            :label="$t('attributes.mobile') + $t('attributes.display')"
          >
            <b-switch v-model="form.mobile_show" name="mobile_show"></b-switch>
          </form-group>
          <form-group
            horizontal
            name="name"
            attribute="attributes.name"
            :label="$t('attributes.name')"
          >
            <b-input
              v-model="form.name"
              name="name"
              :placeholder="$t('message.please_input') + $t('attributes.name')"
              expanded
            >
            </b-input>
          </form-group>
          <form-group
            horizontal
            name="url"
            attribute="attributes.url"
            :label="$t('attributes.url')"
          >
            <b-input
              v-model="form.url"
              name="url"
              :placeholder="$t('message.please_input') + $t('attributes.url')"
              expanded
            >
            </b-input>
          </form-group>
        </form-wrapper>
      </section>
      <footer class="modal-card-foot">
        <b-button class="is-fullwidth" @click="$parent.close()">
          {{ $t('attributes.close') }}
        </b-button>
        <b-button
          :loading="sending"
          type="is-primary"
          class="is-fullwidth"
          native-type="submit"
        >
          {{ $t('attributes.add') }}
        </b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'ThemeForm',
  props: {
    attribute: String
  },
  data() {
    return {
      sending: false,
      formTitle: this.attribute === 'header' ? '新增Header' : '新增Footer',
      loading: false,
      sort_range: [...Array(10).keys()].map(i => i + 1),

      form: this.extractFormValues()
    }
  },
  validations: {
    form: {
      sort: { required },
      attribute: { required },
      english_name: { maxLength: maxLength(50) },
      name: { required, maxLength: maxLength(50) },
      url: { maxLength: maxLength(500) },
      pc_show: { required },
      mobile_show: { required },
      status: {}
    }
  },
  methods: {
    extractFormValues() {
      return {
        sort: 1,
        attribute: this.attribute,
        english_name: '',
        name: '',
        url: '',
        pc_show: false,
        mobile_show: false,
        status: true
      }
    },
    async onSend() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.$emit('onSend', this.form)
    }
  }
}
</script>
